/* eslint-disable class-methods-use-this */
import Popup from './popup';

export default class CourseRearrange extends Popup {
  createComponent() {
    return document.createElement(`au-${this.type}`);
  }

  setAttributes(courseRearrange) {
    courseRearrange.setAttribute('scroll', true);
    courseRearrange.setAttribute('offset', 0);
    courseRearrange.setAttribute('limit', 40);
    courseRearrange.setAttribute(
      'univ-semantic-name',
      this.pathQueryMap.pathMap.univ
    );
    if (
      this.pathQueryMap.pathMap.track &&
      this.pathQueryMap.pathMap.track !== null &&
      this.pathQueryMap.pathMap.track !== ''
    )
      courseRearrange.setAttribute(
        'track-semantic-name',
        this.pathQueryMap.pathMap.track
      );
    else courseRearrange.setAttribute('track-semantic-name', '');

    courseRearrange.setAttribute('page', this.pathQueryMap.pathMap.page);

    return courseRearrange;
  }
}
